import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../../ui';
import { Star } from '../../../../ui/Star';
import { Copy, Flexer, Title } from '../../elements/LayoutElements';
import { useTemplateData, useTemplateStarred } from '../TemplateHooks';
import { TemplateCard } from './TemplateCard';
import { TemplateWithStarData } from './TemplateListView';

const Example = ({ template }: { template: TemplateWithStarData }) => {

    const [starred, toggleStarred] = useTemplateStarred(template);

    return <TemplateCard>
        <TemplateCard.Image>
            <img src={template.thumbUrl} />
        </TemplateCard.Image>
        <TemplateCard.Info>
            <TemplateCard.Header>
                <TemplateCard.Label title={template.label}>
                    {template.label}
                </TemplateCard.Label>
            </TemplateCard.Header>
            <TemplateCard.Body>
                <Copy>{template.description}</Copy>
            </TemplateCard.Body>
            <TemplateCard.Footer>
                <TemplateCard.Author>
                    By Metro Retro
                </TemplateCard.Author>
                <TemplateCard.StarButton>
                    <Star size="2" active={starred} onClick={toggleStarred} />
                </TemplateCard.StarButton>
            </TemplateCard.Footer>
        </TemplateCard.Info>
    </TemplateCard>;
};

const Scribble = styled.span`
    font-family: "Kalam";
    font-size: 1.5rem;
    transform: rotate(-10deg);
    color: ${Colors.observe};
`;

const ClickHere = () => {

    return <Flexer flex="row" center gap=".5">
        <svg width="59" height="21" viewBox="0 0 59 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M57.2188 13.5C48.5521 15 25.8188 16 4.21875 8" stroke={Colors.observe} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.50291 18.5464L1.89899 6.73489L15.0603 1.93598" stroke={Colors.observe} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <Scribble>Click here</Scribble>
    </Flexer>;
};


export const StarredEmpty = () => {

    const { templates } = useTemplateData();
    if (!templates?.length) return null;
    const t = templates[0];

    return <Flexer grow flex="column" center gap="2" padding="2" borderRadius="1" background={Colors.borderLight}>
        <Title size="2xl" color={Colors.textLight} flush>{'You haven\'t starred any templates yet.'}</Title>
        <Flexer flex="row" align="end" justify="center" gap="2">
            <Example template={t} />
            <Flexer relative maxWidth="16" flex="column" align="start" gap="2">
                <Flexer flex="column" align="start" gap=".5">
                    <Title color={Colors.textLight} flush>Star a Template</Title>
                    <Copy flush color={Colors.textLighter}>
                        We all have our favourites! Easily tag yours when browsing templates so you can quickly find them again.
                    </Copy>
                </Flexer>
                <Flexer relative left="-1">
                    <ClickHere />
                </Flexer>
            </Flexer>
        </Flexer>
    </Flexer>;
};
